import React, { useState, useEffect } from 'react';

const MoreLinkBlurb = ({ onNavigateToOtherBooks, isVisible, isLeft = false, bounceDelay = 3 }) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      setIsFadingOut(false);
    } else if (shouldRender) {
      // Start fade out
      setIsFadingOut(true);
      // Remove from DOM after animation completes
      const timer = setTimeout(() => {
        setShouldRender(false);
        setIsFadingOut(false);
      }, 300); // Match CSS transition duration
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, shouldRender]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div 
      className={`more-link-blurb clickable ${isLeft ? 'left-blurb' : ''} ${isFadingOut ? 'fade-out' : ''}`}
      style={{
        animationDelay: `${bounceDelay}s`
      }}
      onClick={onNavigateToOtherBooks}
    >
      <img src="/assets/images/others.png" alt="More Books" />
      <h3>& More...</h3>
    </div>
  );
};

export default MoreLinkBlurb;
